export default __webpack_public_path__ + "static/8-ad3ca9044efd1c47e575adbab2387d3c.png";